module.exports = {"141002001":"解放路街道","141002002":"鼓楼西街街道","141002003":"水塔街街道","141002004":"南街街道","141002005":"乡贤街街道","141002006":"辛寺街街道","141002007":"铁路东街道","141002008":"车站街街道","141002009":"汾河街道","141002010":"滨河","141002100":"屯里镇","141002101":"乔李镇","141002102":"大阳镇","141002103":"县底镇","141002104":"刘村镇","141002105":"金殿镇","141002106":"吴村镇","141002107":"土门镇","141002108":"魏村镇","141002109":"尧庙镇","141002200":"段店乡","141002201":"贾得乡","141002202":"贺家庄乡","141002203":"一平垣乡","141002204":"枕头乡","141002205":"河底乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141002.json
// module id = 361
// module chunks = 0